import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store/index";
// Pages
import LoadingPage from "@/views/LoadingPage/LoadingPage.vue";
import Dashboard from "@/views/Dashboard/Dashboard.vue";
import Preparation from "@/views/Preparation/Preparation.vue";
import OrderDetail from "@/views/OrderDetail/OrderDetail.vue";
import Stock from "@/views/Stock/Stock.vue";
import BlockingConsultation from "@/views/BlockingConsultation/BlockingConsultation.vue";
import OneBlockage from "@/views/OneBlockage/OneBlockage.vue";
import TransportTracking from "@/views/TransportTracking/TransportTracking.vue";
import Settings from "@/views/Settings/Settings.vue";
import ReleaseNotes from "@/views/ReleaseNotes/ReleaseNotes.vue";
import NotFound from "@/views/NotFound/NotFound.vue";
// Back-Office
import Warehouses from "@/views/BackOffice/Warehouses/Warehouses.vue";
import Clients from "@/views/BackOffice/Clients/Clients.vue";
import Users from "@/views/BackOffice/Users/Users.vue";
import WarehouseToCompany from "@/views/BackOffice/WarehouseToCompany/WarehouseToCompany.vue";
import DashboardBO from "@/views/BackOffice/Dashboard/DashboardBO.vue";
import Stats from "@/views/BackOffice/Stats/Stats.vue";
import UsersFeedbacks from "@/views/BackOffice/UsersFeedbacks/UsersFeedbacks.vue";
import ChangeClient from "@/views/BackOffice/ChangeClient/ChangeClient.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "loading",
    component: LoadingPage,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/preparation",
    name: "Préparation des commandes",
    component: Preparation,
  },
  {
    path: "/detailCommande/:reference",
    name: "Détail de la commande",
    component: OrderDetail,
    props: true,
  },
  {
    path: "/stock",
    name: "Consultation des stocks",
    component: Stock,
  },
  {
    path: "/consultationBlocages",
    name: "Consultation des blocages",
    component: BlockingConsultation,
  },
  {
    path: "/consultationBlocage/:reference/:warehouse/:lot",
    name: "Consultation du blocage",
    component: OneBlockage,
    props: true,
  },
  {
    path: "/suiviTransport",
    name: "Transport Tracking",
    component: TransportTracking,
  },
  {
    path: "/infos-maj",
    name: "ReleaseNotes",
    component: ReleaseNotes,
  },
  // Back-Office
  {
    path: "/parametres",
    name: "Paramètres",
    meta: { requiresAdminRole: true },
    component: Settings,
  },
  {
    path: "/parametres/entrepots",
    name: "BO : Entrepôts",
    meta: { requiresAdminRole: true },
    component: Warehouses,
  },
  {
    path: "/parametres/clients",
    name: "BO : Clients",
    meta: { requiresAdminRole: true },
    component: Clients,
  },
  {
    path: "/parametres/utilisateurs",
    name: "BO : Utilisateurs",
    meta: { requiresAdminRole: true },
    component: Users,
  },
  {
    path: "/parametres/entrepot-client",
    name: "BO : Entrepôts - clients",
    meta: { requiresAdminRole: true },
    component: WarehouseToCompany,
  },
  {
    path: "/parametres/statistiques",
    name: "BO - Stats",
    meta: { requiresAdminRole: true },
    component: Stats,
  },
  {
    path: "/parametres/dashboard",
    name: "BO - Dashboard",
    meta: { requiresAdminRole: true },
    component: DashboardBO,
  },
  {
    path: "/parametres/retours-utilisateurs",
    name: "BO - Feedbacks",
    meta: { requiresAdminRole: true },
    component: UsersFeedbacks,
  },
  {
    path: "/parametres/change-client",
    name: "BO - Changer de clients",
    meta: { requiresAdminRole: true },
    component: ChangeClient,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Page introuvable",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.name ?? "";
  if (to.matched.some((record) => record.meta.requiresAdminRole)) {
    if (!store.getters.role) {
      next("/error");
    } else {
      next();
    }
  }
  next();
});

export default router;
